// Écran de connexion : la porte du tableau de service, dessinée sans la coquille (renderApp l'appelle dans
// #app-shell quand !state.isAuthenticated). Peu de choses, lisibles : le titre, une phrase, la carte de connexion
// (atteinte en premier au téléphone), la suite des J d'un item en une bande, et six fonctions en une ligne chacune.
// Les actions historiques login / register restent les seules à parler au serveur ; ce module valide, place
// l'erreur, se souvient de l'adresse sur cet appareil et redessine.
import { html, attr } from '../../core/html.js';
import { state } from '../../core/store.js';
import { actions } from '../../core/actions.js';
import { CLES } from '../../core/storage.js';
import { ico } from '../icones.js';
import { themeEffectif } from '../theme.js';
import { J_DEFAUT } from '../components/accueil-sequence.js';

var mode = 'login';       // 'login' | 'register' : le module survit aux redessins, pas au rechargement
var envoi = false;        // un envoi est parti : le bouton tourne, un second Entrée n'envoie rien
var erreurChamp = null;   // 'email' | 'pwd' | 'form' : où poser state.authError (nos validations le disent ; le serveur, non)
var voirMdp = false;      // mot de passe affiché en clair (gardé d'un redessin à l'autre)
var adresseLue = false;   // l'adresse retenue sur cet appareil n'est relue qu'une fois

// L'adresse e-mail retenue sur cet appareil (jamais le mot de passe) : elle préremplit le champ la fois suivante.
function adresseRetenue() { try { return localStorage.getItem(CLES.adresseConnexion) || ''; } catch (e) { return ''; } }
function retenirAdresse(v) { try { if (v) localStorage.setItem(CLES.adresseConnexion, v); else localStorage.removeItem(CLES.adresseConnexion); } catch (e) {} }

function pointeurFin() { try { return window.matchMedia('(hover: hover) and (pointer: fine)').matches; } catch (e) { return false; } }
function valeur(id) { var el = document.getElementById(id); return el ? el.value : ''; }
function focaliser(sel) { var el = document.querySelector(sel); if (el && el.focus) { try { el.focus({ preventScroll: true }); } catch (e) {} } }
// Après un redessin, le focus retombe sur body : on le repose à l'image suivante, seulement si rien d'autre ne l'a
// pris entre-temps (quelqu'un qui tape déjà dans un champ garde son champ).
function refocusSiLibre(sel) { requestAnimationFrame(function() { if (!document.activeElement || document.activeElement === document.body) focaliser(sel); }); }

// Où s'affiche state.authError : sous le champ que nos validations ont désigné, sinon d'après le message du serveur
// (identifiants → mot de passe, adresse déjà prise → e-mail, serveur injoignable → en tête du formulaire).
function ouErreur() {
    var m = state.authError || '';
    if (!m) return null;
    if (erreurChamp) return erreurChamp;
    if (/injoignable|serveur|réessa|indisponible/i.test(m)) return 'form';
    if (/mail|adresse|existe|déjà|utilis/i.test(m)) return 'email';
    return 'pwd';
}

// Six fonctions, une ligne chacune : ce qu'on trouve dedans, sans démonstration.
var FONCTIONS = [
    ['calendar-dots', 'Planning J', 'un jour sauté, tout se recale.'],
    ['check-square', 'Séance du jour', 'fiche, podcast et QCM réunis.'],
    ['list-checks', 'QCM', 'barème EDN, maîtrise par notion.'],
    ['cards-three', 'Flashcards', 'répétition espacée, active recall.'],
    ['chart-bar', 'Partiels', 'où tu en es pour chacun.'],
    ['newspaper', 'LCA', 'cours, méthode et annales.'],
];

function champ(o) {
    var invalide = o.invalide;
    return html`<div class="champ${o.classe ? ' ' + o.classe : ''}"${invalide ? html` data-invalide` : ''}>
        <label for="${o.id}">${o.label}</label>
        ${o.corps}
        ${o.aide && !invalide ? html`<p class="aide" id="${o.id}-aide">${o.aide}</p>` : ''}
        ${invalide ? html`<p class="erreur" id="${o.id}-erreur" role="alert">${ico('warning-circle', { taille: 14 })}<span>${state.authError}</span></p>` : ''}
        ${o.apres || ''}
    </div>`;
}

function formulaire() {
    var inscription = mode === 'register', ou = ouErreur();
    var email = state.authEmail || '', pwd = state.authPassword || '';
    var retenue = adresseRetenue(), memorisee = !!retenue && email === retenue && ou !== 'email';
    var decrit = function(id, aide) {
        var cle = id === 'auth-email' ? 'email' : 'pwd', refs = [];
        if (ou === cle) refs.push(id + '-erreur'); else if (aide) refs.push(id + '-aide');
        if (id === 'auth-pwd') refs.push('auth-pwd-maj');   // l'alerte majuscules est lue avec le champ
        return refs.length ? html` aria-describedby="${refs.join(' ')}"` : '';
    };
    return html`<section class="carte cx-carte" aria-labelledby="cx-form-titre">
        <form id="connexion-form" class="cx-form" method="post" novalidate${envoi ? html` aria-busy="true"` : ''}>
            <h2 id="cx-form-titre">${inscription ? 'Créer un compte' : 'Connexion'}</h2>
            ${ou === 'form' ? html`<p class="cx-alerte" role="alert">${ico('warning-circle', { taille: 18 })}<span>${state.authError}</span></p>` : ''}
            ${champ({ id: 'auth-email', label: 'Adresse e-mail', invalide: ou === 'email',
                corps: html`<input id="auth-email" class="saisie" type="email" name="email" autocomplete="username" inputmode="email" autocapitalize="off" spellcheck="false" enterkeyhint="next" value="${email}" data-champ="authEmail" data-live data-input-action="connexionSaisie"${ou === 'email' ? html` aria-invalid="true"` : ''}${decrit('auth-email')}>`,
                apres: memorisee ? html`<p class="aide cx-retenue">Adresse retenue sur cet appareil. <button type="button" class="lien-bouton" data-action="connexionOublierAdresse">Oublier</button></p>` : '' })}
            ${champ({ id: 'auth-pwd', label: 'Mot de passe', invalide: ou === 'pwd', aide: inscription ? '8 caractères minimum.' : '', classe: 'cx-champ-mdp',
                corps: html`<div class="cx-mdp"><input id="auth-pwd" class="saisie" type="${voirMdp ? 'text' : 'password'}" name="password" autocomplete="${inscription ? 'new-password' : 'current-password'}" enterkeyhint="go" value="${pwd}" data-champ="authPassword" data-live data-input-action="connexionSaisie"${ou === 'pwd' ? html` aria-invalid="true"` : ''}${decrit('auth-pwd', inscription)}><button type="button" class="ico-btn cx-oeil" data-action="connexionVoirMdp" aria-pressed="${voirMdp ? 'true' : 'false'}" aria-label="${voirMdp ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}" title="${voirMdp ? 'Masquer le mot de passe' : 'Afficher le mot de passe'}">${ico(voirMdp ? 'eye-slash' : 'eye')}</button></div>`,
                apres: html`<p id="auth-pwd-maj" class="cx-maj" aria-live="polite"></p>` })}
            <button id="connexion-envoyer" type="submit" class="btn btn-primaire btn-pleine"${envoi ? html` aria-busy="true"` : ''}>${inscription ? 'Créer mon compte' : 'Se connecter'}</button>
            ${inscription ? '' : html`<p class="cx-liens"><a href="${window.pageUrl('mot-de-passe-oublie')}">Mot de passe oublié ?</a></p>`}
        </form>
        <p class="cx-alt">${inscription
            ? html`Déjà un compte ? <button type="button" class="lien-bouton" data-action="connexionMode" data-args="${attr(['login'])}">Se connecter</button>`
            : html`Pas encore de compte ? <button type="button" class="lien-bouton" data-action="connexionMode" data-args="${attr(['register'])}">Créer un compte</button>`}</p>
        ${inscription ? html`<p class="cx-consentement">En créant un compte, tu acceptes les <a href="${window.pageUrl('cgv')}">conditions d'utilisation</a> et la <a href="${window.pageUrl('confidentialite')}">politique de confidentialité</a>.</p>` : ''}
    </section>`;
}

export function renderConnexion() {
    var th = themeEffectif(), ou = ouErreur();
    envoi = false;   // tout redessin vient d'une réponse (ou d'une validation) : l'envoi précédent est fini
    // L'adresse retenue préremplit le champ une fois ; le focus ira alors au mot de passe.
    if (!adresseLue) { adresseLue = true; if (!state.authEmail) state.authEmail = adresseRetenue(); }
    // Le focus : sur le champ fautif après une erreur ; sinon sur l'adresse, seulement au pointeur fin (au doigt,
    // ouvrir le clavier sans qu'on l'ait demandé cacherait la preuve).
    if (ou === 'email' || ou === 'pwd') refocusSiLibre(ou === 'email' ? '#auth-email' : '#auth-pwd');
    else if (pointeurFin()) refocusSiLibre(state.authEmail ? '#auth-pwd' : '#auth-email');
    return html`<div class="cx">
        <div class="rails"><header class="rail-haut"><div class="rail-inner">
            <a class="marque" href="${window.routeUrl('accueil')}" aria-label="EDN Planner, accueil"><span class="marque-carre">EDN</span><span>Planner</span></a>
            <div class="rail-droite">
                <button type="button" class="ico-btn" data-action="connexionTheme" title="Passer en mode ${th === 'nuit' ? 'jour' : 'nuit'}" aria-label="Passer en mode ${th === 'nuit' ? 'jour' : 'nuit'}">${ico(th === 'nuit' ? 'sun' : 'moon')}</button>
            </div>
        </div></header></div>
        <main class="cx-main">
            <div class="cx-intro">
                <h1 class="cx-titre">Chaque item revient au bon moment.</h1>
                <p class="cx-these">Le planning de révision des EDN : chaque item est replacé de J0 à J60, avec tout ce qu'il faut pour chaque séance.</p>
            </div>
            ${formulaire()}
            <div class="cx-plus">
                <ol class="cx-js" aria-label="Un item revient à J0, J1, J3, J7, J14, J30 puis J60">${J_DEFAUT.map(function(j) {
                    return html`<li class="seance-j${j === 0 ? ' seance-j--j0' : ''}">J${j}</li>`;
                })}</ol>
                <ul class="cx-fonctions" aria-label="Ce que tu trouves dedans">${FONCTIONS.map(function(f) {
                    return html`<li>${ico(f[0], { taille: 20 })}<p><strong>${f[1]}</strong> : ${f[2]}</p></li>`;
                })}</ul>
            </div>
        </main>
        <footer class="pied cx-pied">
            <a href="${window.pageUrl('mentions-legales')}">Mentions légales</a>
            <a href="${window.pageUrl('confidentialite')}">Confidentialité</a>
            <a href="${window.pageUrl('cgv')}">CGU / CGV</a>
            <span class="droite">© ${new Date().getFullYear()} · outil personnel de révision, non affilié au CNG.</span>
        </footer>
    </div>`;
}

// --- actions déléguées
function erreur(champ, message) { state.authError = message; erreurChamp = champ; window.renderApp(); focaliser(champ === 'email' ? '#auth-email' : '#auth-pwd'); }

actions.connexionSoumettre = function() {
    if (envoi) return;
    var email = valeur('auth-email'), pwd = valeur('auth-pwd');
    state.authEmail = email; state.authPassword = pwd;   // gardés pour le redessin : l'erreur ne vide jamais la saisie
    if (!email.trim()) return erreur('email', 'Adresse e-mail manquante.');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim())) return erreur('email', 'Cette adresse ne ressemble pas à une adresse e-mail.');
    if (!pwd) return erreur('pwd', 'Mot de passe manquant.');
    if (mode === 'register' && pwd.length < 8) return erreur('pwd', 'Mot de passe : 8 caractères minimum.');
    state.authError = ''; erreurChamp = null; envoi = true;
    var b = document.getElementById('connexion-envoyer'), f = document.getElementById('connexion-form');
    if (b) b.setAttribute('aria-busy', 'true');
    if (f) f.setAttribute('aria-busy', 'true');
    // Les actions historiques parlent au serveur : succès → rechargement ; échec → state.authError + renderApp.
    if (mode === 'register') actions.register(); else actions.login();
};
actions.connexionMode = function(m) {
    mode = m === 'register' ? 'register' : 'login';
    state.authError = ''; erreurChamp = null;
    window.renderApp();
    focaliser(state.authEmail ? '#auth-pwd' : '#auth-email');
};
// Corriger un champ retire son erreur sur place (pas de redessin : la saisie continue).
actions.connexionSaisie = function(el) {
    var c = el && el.closest ? el.closest('.champ') : null;
    if (!c || !c.hasAttribute('data-invalide')) return;
    c.removeAttribute('data-invalide'); el.removeAttribute('aria-invalid');
    var p = c.querySelector('.erreur'); if (p) p.remove();
    state.authError = ''; erreurChamp = null;
};
actions.connexionVoirMdp = function(el) {
    var i = document.getElementById('auth-pwd'); if (!i) return;
    voirMdp = !voirMdp;
    i.type = voirMdp ? 'text' : 'password';
    el.setAttribute('aria-pressed', voirMdp ? 'true' : 'false');
    el.setAttribute('aria-label', voirMdp ? 'Masquer le mot de passe' : 'Afficher le mot de passe'); el.title = el.getAttribute('aria-label');
    el.innerHTML = String(ico(voirMdp ? 'eye-slash' : 'eye'));
    try { i.focus({ preventScroll: true }); var n = i.value.length; i.setSelectionRange(n, n); } catch (e) {}
};
// Le serveur a accepté l'adresse (connexion ou inscription réussie) : elle seule est retenue, jamais le mot de
// passe — une adresse mal tapée ou refusée ne revient pas préremplie la fois suivante.
window.connexionReussie = function(email) { retenirAdresse(String(email || '').trim()); };

// Oublier l'adresse retenue (un ordinateur partagé) : le champ se vide et reprend le focus.
actions.connexionOublierAdresse = function() {
    retenirAdresse('');
    state.authEmail = '';
    window.renderApp();
    focaliser('#auth-email');
};
// Majuscules verrouillées pendant qu'on tape le mot de passe : la page le dit sous le champ (annoncé, pas en couleur seule).
function majuscules(ev) {
    if (!ev.target || ev.target.id !== 'auth-pwd' || !ev.getModifierState) return;
    var p = document.getElementById('auth-pwd-maj');
    if (!p) return;
    var on = ev.getModifierState('CapsLock');
    if (on && !p.textContent) p.innerHTML = String(html`${ico('warning', { taille: 14 })}<span>Majuscules activées</span>`);
    else if (!on && p.textContent) p.textContent = '';
}
document.addEventListener('keydown', majuscules);
document.addEventListener('keyup', majuscules);

// La bascule jour/nuit sans coquille : le thème change (fondu), le bouton se met à jour sur place.
actions.connexionTheme = function(el) {
    actions.toggleTheme();
    var th = themeEffectif();
    el.innerHTML = String(ico(th === 'nuit' ? 'sun' : 'moon'));
    el.setAttribute('aria-label', 'Passer en mode ' + (th === 'nuit' ? 'jour' : 'nuit')); el.title = el.getAttribute('aria-label');
};
// Entrée dans un champ soumet le formulaire (soumission implicite du navigateur) : c'est nous qui l'envoyons.
document.addEventListener('submit', function(ev) {
    var f = ev.target;
    if (!f || f.id !== 'connexion-form') return;
    ev.preventDefault();
    actions.connexionSoumettre();
});

window.renderConnexion = renderConnexion;
